<template>
    <div class="report__dashboard_show_coursecompletionoverview_table">
        <component-table
            :labels="[
                {
                    key: 'name',
                    title: 'Course name',
                    type: 'string',
                    sortable: true,
                    queryable: false
                },
                {
                    key: 'active',
                    title: 'Enrolled',
                    type: 'number',
                    sortable: true,
                    queryable: false
                },
                {
                    key: 'completed',
                    title: 'Completed',
                    type: 'number',
                    sortable: true,
                    queryable: false
                }
            ]"
            :items="items"
            :component-table-item="ReportDashboardShowCourseCompletionOverviewTableItem"
        ></component-table>
    </div>
</template>

<script>

import ComponentTable from '@/components/default/shared/ComponentTable'
import ReportDashboardShowCourseCompletionOverviewTableItem from '@/components/ebs/reports/dashboard/show/ReportDashboardShowCourseCompletionOverviewTableItem'

export default {
  name: 'report-dashboard-show-course-completion-overview-table',
  components: { ComponentTable },
  data () {
    return {
      ReportDashboardShowCourseCompletionOverviewTableItem
    }
  },
  props: {
    items: {
      type: Array
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportdashboardcoursecompletionoverview.scss";
</style>
